import {useAuth} from "hooks/useAuth";
import {type FC, useEffect} from "react";
import {registerUnauthorizedHandler} from "services/http/authInterceptor";

const AuthInterceptorBridge: FC = () => {
  const {clearUser} = useAuth();

  useEffect(() => {
    registerUnauthorizedHandler(() => {
      clearUser();
    });
  }, [clearUser]);

  return null;
};

export default AuthInterceptorBridge;
